import { cn } from "@hulahoop/ui";

export type CountTone = "destructive" | "warning" | "neutral";

const TONE: Record<CountTone, string> = {
  destructive: "bg-destructive-subtle text-destructive",
  warning: "bg-warning-subtle text-warning",
  neutral: "bg-muted text-foreground",
};

export function CountPill({ n, tone = "neutral" }: { n: number; tone?: CountTone }) {
  return (
    <span
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-sm px-1 text-xs font-medium tabular-nums",
        TONE[tone],
      )}
    >
      {n}
    </span>
  );
}
